import { ShieldCheck } from '@drift-labs/icons';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import Drawer from '../Drawer';
import Utility from '../Inputs/Utility';
import { Typo } from '../Text/Typo';
import Button from '../Button';
import Link from 'next/link';

const VAULTS_APPLICATION_FORM_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSeC64AEy84bQfBquJLc5cWAv2HxslnK0Aik4ezMf9Ubh-hK5g/viewform';

export const ListYourVaultDrawer = () => {
	const handleCloseDrawer = useDrawersStore((s) => s.handleCloseDrawer);

	return (
		<Drawer
			drawerName="listYourVault"
			className="w-full sm:max-w-[400px] sm:w-[400px] "
		>
			<Drawer.Header
				titleContent={'List your vault'}
				className="py-4"
				onClose={() => handleCloseDrawer('listYourVault')}
			/>

			<Drawer.Body>
				<div className="flex flex-col text-text-default p-4 space-y-4">
					<Typo.T3>Drift recognizes two types of Vault Managers:</Typo.T3>

					<div className="flex flex-col space-y-1">
						<Typo.T5>Ecosystem Vault Managers</Typo.T5>
						<Typo.B5 className="text-text-secondary">
							These managers have met Drift’s Strategy Vaults onboarding
							criteria. While Strategy Vaults on Drift are
							permissionless—allowing anyone with the technical expertise to
							create and manage one—only those who successfully complete
							onboarding will be listed on the Drift Strategy Vaults page.
						</Typo.B5>
					</div>

					<div className="flex flex-col space-y-1">
						<span className="flex items-center space-x-1">
							<Typo.T5>Verified Vault Managers </Typo.T5>
							<ShieldCheck gradientColors={['#E8A2A0', '#9468F1', '#71CCE9']} />
						</span>
						<Typo.B5 className="text-text-secondary">
							These managers have met Drift’s Strategy Vaults onboarding
							criteria. While Strategy Vaults on Drift are
							permissionless—allowing anyone with the technical expertise to
							create and manage one—only those who successfully complete
							onboarding will be listed on the Drift Strategy Vaults page.
						</Typo.B5>
					</div>

					<Utility.VERTDIVIDER />

					<div className="flex flex-col space-y-1">
						<span className="flex items-center space-x-1">
							<Typo.T5>How to apply?</Typo.T5>
						</span>
						<Typo.B5 className="text-text-secondary">
							To apply for listing on the Drift Strategy Vaults page as an
							Ecosystem Vault Manager or Verified Vault Manager, please complete
							the following Form or by clicking the button below this side
							panel.
						</Typo.B5>
					</div>

					<Utility.VERTDIVIDER />

					<div className="flex flex-col space-y-1">
						<Typo.T3 className="text-warn-yellow">Before Applying:</Typo.T3>
						<Typo.B5 className="text-text-secondary">
							Check that you meet the requirements.
						</Typo.B5>
					</div>

					<div className="flex flex-col space-y-1">
						<span className="flex items-center space-x-1">
							<Typo.T5>Ecosystem Vault Manager Requirements:</Typo.T5>
						</span>
						<Typo.B5 className="text-text-secondary">
							<ul>
								<li>• Minimum $200K USD in capital to seed the first Vault</li>
								<li>• Proven experience in vault management</li>
								<li>• Clear description of the initial vault strategy</li>
								<li>
									• High-level distribution plan for attracting depositors
								</li>
							</ul>
						</Typo.B5>
					</div>

					<div className="flex flex-col space-y-1">
						<span className="flex items-center space-x-1">
							<Typo.T5>Verified Vault Manager Requirements:</Typo.T5>
						</span>
						<Typo.B5 className="text-text-secondary">
							<ul>
								<li>• Fulfill all Ecosystem Vault Manager requirements</li>
								<li>
									• Submit basic KYB documentation for the entity operating the
									Vault
								</li>
							</ul>
						</Typo.B5>
					</div>
				</div>
			</Drawer.Body>

			<Drawer.Footer>
				<Link href={VAULTS_APPLICATION_FORM_URL} target="_blank">
					<Button.Gradient size="LARGE" className="w-full">
						View Form
					</Button.Gradient>
				</Link>
			</Drawer.Footer>
		</Drawer>
	);
};
